// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";

// import styles bundle
import "swiper/css/bundle";

import fslightbox from "fslightbox";

const productDetailCarouselThumbs = new Swiper(".product-gallery--thumbs", {
    speed: 300,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slidesPerView: 3,
    spaceBetween: 16,
    breakpoints: {
        576: {
            slidesPerView: 4,
        },
    },
});

const productDetailCarouselFull = new Swiper(".product-gallery--full", {
    speed: 300,
    slidesPerView: 1,
    thumbs: {
        swiper: productDetailCarouselThumbs,
    },
    navigation: {
        prevEl: ".gallery-nav--prev",
        nextEl: ".gallery-nav--next",
        lockClass: "gallery-nav--disabled",
    },
});
